<div class="public-mls" *ngIf="name">
	<div class="public-mls__header">
		<img [src]="getListInfo(name).brand" [alt]="getListInfo(name).name" />
		<ul>
			<li><strong>Source</strong>: {{ getListInfo(name).name }}</li>
		</ul>
	</div>

	<div class="public-mls__content">
		IDX information is provided exclusively for personal, non-commercial use, and may not be used for any purpose other
		than to identify prospective properties consumers may be interested in purchasing. Information is deemed reliable
		but not guaranteed. Some IDX listings have been excluded from this website.
	</div>
</div>
